module.exports = __webpack_public_path__ + "static/img/clock.e11bae3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/seo/clock.png
// module id = Wv8N
// module chunks = 69